import { createSelector } from "@ngrx/store";
import { IStore } from "../store";

export const getPaymentState = createSelector(
    (store: IStore) => store.payment,
    store => store,
);
